import { Fragment, useEffect, useState } from 'react';
import { Col, Row, Breadcrumb, Card, Tab, Nav, Form, Button, OverlayTrigger, Tooltip, Spinner } from 'react-bootstrap';
import { FormSelect } from 'components/elements/form-select/FormSelect';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

// Import authentication components
import useAuthHeader from 'react-auth-kit/hooks/useAuthHeader';
import useAuthUser from 'react-auth-kit/hooks/useAuthUser';

// import notification component
import Notification, { handleShowNotification } from 'components/elements/notification/Notification';

const CompanySettings = () => {
	const { t } = useTranslation(); // useTranslation-Hook
	const [notification, setNotification] = useState({ variant: '', title: '', message: '' });
	const [isLoading, setIsLoading] = useState(null); // State for loading table
	const [isLoadingButtonInfoInvoice, setIsLoadingButtonInfoInvoice] = useState(null); // State for loading spinner
	const [isCheckboxInfoInvoice, setIsCheckboxInfoInvoice] = useState(false); // State checkbox Info Invoice

	const auth = useAuthUser(); // Assuming this gets the auth user data

	// Form Data Tenant
	const [formDataTenant, setFormDataTenant] = useState({
		tenant_id: '',
		tenant_name: '',
		tenant_slug: '',
		tenant_registered_timestamp: ''
	});
	const [dataTenant, setDataTenant] = useState(null); // Add data state
	
	// Checkbox Info Invoice
	const onChangeInfoInvoice = (e) => {
		const isChecked = e.target.checked;
		setIsCheckboxInfoInvoice(isChecked);
	};

	// Form Data Invoice
	const [formDataInfoInvoice, setFormDataInfoInvoice] = useState({
		info_invoice_id: '',
		info_invoice_contact: '',
		info_invoice_email_address: '',
		info_invoice_company: '',
		info_invoice_street: '',
		info_invoice_streetnr: '',
		info_invoice_zip: '',
		info_invoice_city: '',
		info_invoice_state: '',
		info_invoice_country: '',
		info_invoice_payment_method: ''
	});
	const [dataInvoice, setDataInvoice] = useState(null); // Add data state
	
	// Country Options
	const countryOptions = [
		{ value: 'Deutschland', label: 'Deutschland' },
		{ value: 'Österreich', label: 'Österreich' },
		{ value: 'Schweiz', label: 'Schweiz' }
	];
	// Add selected country to the top of the list
	if (formDataInfoInvoice.info_invoice_country) {
		const selectedCountry = countryOptions.find(option => option.value === formDataInfoInvoice.info_invoice_country);
		if (selectedCountry) {
			countryOptions.unshift(selectedCountry);
		}
	}

	// API-Call Options
	const authHeader = useAuthHeader();
	const options = {
		params: {
			
		},
		headers: {
			Authorization: authHeader,
			Accept: 'application/json'
		}
	};

	// API-Call for all Data
	const getData = async () => {
		setIsLoading(true);
		// Dynamische URL basierend auf der Umgebung
		const baseURL = process.env.REACT_APP_ENV === 'development'
			? `http://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`
			: `https://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`;

		// Tenant Data
		await axios.get(`${baseURL}/tenants/${auth.tenant_id}`, options)
			.then(response => {
				const responseData = response.data.data; // Extract the data from the response
				setDataTenant({ data: responseData });
				setFormDataTenant({
					tenant_id: responseData.id || '',
					tenant_slug: responseData.tenant_slug || '',
					tenant_name: responseData.tenant_name || '',
					tenant_registered_timestamp: responseData.tenant_registered_timestamp || ''
				});
				setIsLoading(false);
			})
			.catch((error) => {
				setIsLoading(false);
				const errorMessage = error.response?.data?.message ? error.message + '. ' + error.response.data.message : error.message;
				handleShowNotification(setNotification, 'danger', 'Fehler', errorMessage + '. Bitte versuche es erneut oder kontaktiere den HelpDesk.');
			});

		// Invoice Data
		await axios.get(`${baseURL}/tenants/${auth.tenant_id}/info`, options)
			.then(response => {
				const responseData = response.data.data; // Extract the data from the response
				setDataInvoice({ data: responseData });
				setFormDataInfoInvoice({
					info_invoice_id: responseData.id || '',
					info_invoice_contact: responseData.info_invoice_contact || '',
					info_invoice_email_address: responseData.info_invoice_email_address || '',
					info_invoice_company: responseData.info_invoice_company || '',
					info_invoice_street: responseData.info_invoice_street || '',
					info_invoice_streetnr: responseData.info_invoice_streetnr || '',
					info_invoice_zip: responseData.info_invoice_zip || '',
					info_invoice_city: responseData.info_invoice_city || '',
					info_invoice_state: responseData.info_invoice_state || '',
					info_invoice_country: responseData.info_invoice_country || '',
					info_invoice_payment_method: responseData.info_invoice_payment_method || ''
				});
				setIsLoading(false);
				setIsCheckboxInfoInvoice(true);
			})
			.catch((error) => {
				if (error?.response?.status === 404) {
					// do nothing if no data is found
					// set default country
					setFormDataInfoInvoice({
						info_invoice_country: 'Deutschland',
					});
					setIsLoading(false);
					setIsCheckboxInfoInvoice(false);
				} else {
					setIsLoading(false);
					const errorMessage = error.response?.data?.message ? error.message + '. ' + error.response.data.message : error.message;
					handleShowNotification(setNotification, 'danger', 'Fehler', errorMessage + '. Bitte versuche es erneut oder kontaktiere den HelpDesk.');
					setIsCheckboxInfoInvoice(false);
				}				
			});

		
	};

	useEffect(() => {
		getData();
	}, []);

	const handleChange = (e) => {
		const { id, value } = e.target;
		setFormDataInfoInvoice({
			...formDataInfoInvoice,
			[id]: value
		});
	};

	const handleCountryChange = (e) => {
		setFormDataInfoInvoice({
			...formDataInfoInvoice,
			info_invoice_country: e.target.value
		});
	};

	const handleSubmitInfoInvoice = async (e) => {
		e.preventDefault();
		setIsLoadingButtonInfoInvoice(true);

		// Dynamische URL basierend auf der Umgebung
		const baseURL = process.env.REACT_APP_ENV === 'development'
		? `http://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`
		: `https://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`;

		if (!formDataInfoInvoice?.info_invoice_id) {
			await axios.post(`${baseURL}/tenants/${auth.tenant_id}/info`, formDataInfoInvoice, options)
				.then(response => {
					setDataInvoice({ data: response.data.data });
					setIsLoadingButtonInfoInvoice(false);
					handleShowNotification(setNotification, 'success', 'Erfolgreich', 'Deine Daten wurden erfolgreich gespeichert');			
				})
				.catch((error) => {
					console.log(error);
					setIsLoadingButtonInfoInvoice(false);
					const errorMessage = error.response?.data?.message ? error.message + '. ' + error.response.data.message : error.message;
					handleShowNotification(setNotification, 'danger', 'Fehler', errorMessage + '. Bitte versuche es erneut oder kontaktiere den HelpDesk.');		
				});
		} else {
			await axios.patch(`${baseURL}/tenants/${auth.tenant_id}/info/${formDataInfoInvoice.info_invoice_id}`, formDataInfoInvoice, options)
				.then(response => {
					setDataInvoice({ data: response.data.data });
					setIsLoadingButtonInfoInvoice(false);
					handleShowNotification(setNotification, 'success', 'Erfolgreich', 'Deine Daten wurden erfolgreich gespeichert');			
				})
				.catch((error) => {
					console.log(error);
					setIsLoadingButtonInfoInvoice(false);
					const errorMessage = error.response?.data?.message ? error.message + '. ' + error.response.data.message : error.message;
					handleShowNotification(setNotification, 'danger', 'Fehler', errorMessage + '. Bitte versuche es erneut oder kontaktiere den HelpDesk.');		
				});
		}
	};

	const handleSubmitInfoTenant = async (e) => {
		e.preventDefault();
		setIsLoadingButtonInfoInvoice(true);

		// Dynamische URL basierend auf der Umgebung
		const baseURL = process.env.REACT_APP_ENV === 'development'
			? `http://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`
			: `https://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`;

		if (!formData?.id) {
			await axios.post(`${baseURL}/tenants/${auth.tenant_id}/info`, formData, options)
				.then(response => {
					setDataInvoice({ data: response.data.data });
					setIsLoadingButtonInfoInvoice(false);
					handleShowNotification(setNotification, 'success', 'Erfolgreich', 'Deine Daten wurden erfolgreich gespeichert');
				})
				.catch((error) => {
					console.log(error);
					setIsLoadingButtonInfoInvoice(false);
					const errorMessage = error.response?.data?.message ? error.message + '. ' + error.response.data.message : error.message;
					handleShowNotification(setNotification, 'danger', 'Fehler', errorMessage + '. Bitte versuche es erneut oder kontaktiere den HelpDesk.');
				});
		} else {
			await axios.patch(`${baseURL}/tenants/${auth.tenant_id}/info/${formData.id}`, formData, options)
				.then(response => {
					setDataInvoice({ data: response.data.data });
					setIsLoadingButtonInfoInvoice(false);
					handleShowNotification(setNotification, 'success', 'Erfolgreich', 'Deine Daten wurden erfolgreich gespeichert');
				})
				.catch((error) => {
					console.log(error);
					setIsLoadingButtonInfoInvoice(false);
					const errorMessage = error.response?.data?.message ? error.message + '. ' + error.response.data.message : error.message;
					handleShowNotification(setNotification, 'danger', 'Fehler', errorMessage + '. Bitte versuche es erneut oder kontaktiere den HelpDesk.');
				});
		}
	};

	return (
		
		<Fragment>
			{notification.show && (
				<Notification variant={notification.variant} title={notification.title} message={notification.message} show={notification.show} setNotification={setNotification} />
			)}
			<Row>
				{/* tenant settings */}
				<Col xl={{ offset: 1, span: 10 }} lg={{ offset: 1, span: 10 }} md={12}>
					<Card className="mb-4">
						<Card.Header className="d-flex align-items-center justify-content-between">
							<h4 className="mb-0">{t('Tenant')}</h4>
						</Card.Header>
						<Card.Body id="info_tenant">
							{isLoading ? (
								<div className="d-flex justify-content-center">
									<Spinner animation="border" role="status">
										<span className="visually-hidden">Loading...</span>
									</Spinner>
								</div>
							) : (
								<Form onSubmit={handleSubmitInfoTenant}>
									<Row>
										<Col lg={6} md={6} className="mb-3">
											<Form.Group controlId="tenant_id">
												<Form.Label>{t('Tenant ID')}</Form.Label>
												<Form.Control plaintext readOnly type="text" value={formDataTenant.tenant_id} onChange={handleChange} required />
											</Form.Group>
										</Col>
										<Col lg={6} md={6} className="mb-3">
											<Form.Group controlId="tenant_slug">
												<Form.Label>{t('Tenant Slug')}</Form.Label>
												<Form.Control plaintext readOnly type="text" value={formDataTenant.tenant_slug} onChange={handleChange} required />
											</Form.Group>
										</Col>
										<Col lg={6} md={6} className="mb-3">
											<Form.Group controlId="tenant_name">
												<Form.Label>{t('Tenant Name')}</Form.Label>
												<Form.Control plaintext readOnly type="text" value={formDataTenant.tenant_name} onChange={handleChange} required />
											</Form.Group>
										</Col>
										<Col lg={6} md={6} className="mb-3">
											<Form.Group controlId="tenant_registered_timestamp">
												<Form.Label>{t('Registered at')}</Form.Label>
												<Form.Control plaintext readOnly type="text" value={new Date(formDataTenant.tenant_registered_timestamp).toLocaleString()} onChange={handleChange} required />
											</Form.Group>
										</Col>
									</Row>
									<Row>
										<Col lg={12} md={12}>
											<div className="d-flex justify-content-end mt-4">
												<OverlayTrigger
													placement="bottom"
														overlay={<Tooltip id={`tooltip-bottom`}>{t('This function is currently in development and will be available very soon')}</Tooltip>}
												>
													<span className="d-inline-block">
														<Button className="d-end" variant="danger" type="submit" disabled>
															{isLoadingButtonInfoInvoice ? (
																<>
																	<Spinner animation="border" size="sm" className="me-2" />
																	{t('Delete Tenant')}
																</>
															) : (
																t('Delete Tenant')
															)}
														</Button>
													</span>
												</OverlayTrigger>
												
											</div>
										</Col>
									</Row>
								</Form>
							)}
						</Card.Body>
						<Card.Footer className="text-muted d-flex justify-content-end">
							<small>{t('This Tenant is used to identify your company in the system')}</small>
						</Card.Footer>
					</Card>
				</Col>
				{/* invoice settings */}
				<Col xl={{ offset: 1, span: 10 }} lg={{ offset: 1, span: 10 }} md={12}>
					<Card className="mb-4">
						<Card.Header className="d-flex align-items-center justify-content-between">
							<h4 className="mb-0">{t('Invoice and Payment')}</h4>
							<Form>
								<Form.Check
									type="checkbox"
									label=""
									className=" form-switch"
									onChange={onChangeInfoInvoice}
									checked={isCheckboxInfoInvoice}
								/>
							</Form>
						</Card.Header>
						<Card.Body id="info_invoice">
							{isLoading ? (
								<div className="d-flex justify-content-center">
									<Spinner animation="border" role="status">
										<span className="visually-hidden">Loading...</span>
									</Spinner>
								</div>
							) : (
								<Form onSubmit={handleSubmitInfoInvoice} style={{ display: isCheckboxInfoInvoice ? 'block' : 'none' }}>
									<Row>
										<Col lg={12} md={12} className="mb-3 d-none">
											<Form.Group controlId="info_invoice_id">
												<Form.Label visuallyHidden>ID</Form.Label>
													<Form.Control type="text" value={formDataInfoInvoice.info_invoice_id} onChange={handleChange} disabled required />
											</Form.Group>
										</Col>
										<Col lg={6} md={6} className="mb-3">
											<Form.Group controlId="info_invoice_contact">
												<Form.Label>{t('Contact person')}</Form.Label>
													<Form.Control type="text" value={formDataInfoInvoice.info_invoice_contact} onChange={handleChange} required />
											</Form.Group>
										</Col>
										<Col lg={6} md={6} className="mb-3">
											<Form.Group controlId="info_invoice_email_address">
												<Form.Label>{t('Invoice Email')}</Form.Label>
													<Form.Control type="email" value={formDataInfoInvoice.info_invoice_email_address} onChange={handleChange} required />
													<small>
														{t('We use this email to send the invoice after a payment. Please make sure that this email address is correct.')}
													</small>
											</Form.Group>
										</Col>
										<Col lg={12} md={12} className="mb-3">
											<Form.Group controlId="info_invoice_company">
												<Form.Label>{t('Company Name')}</Form.Label>
													<Form.Control type="text" value={formDataInfoInvoice.info_invoice_company} onChange={handleChange} required />
											</Form.Group>
										</Col>
										<Col lg={10} md={10} className="mb-3">
											<Form.Group controlId="info_invoice_street">
												<Form.Label>{t('Street')}</Form.Label>
													<Form.Control type="text" value={formDataInfoInvoice.info_invoice_street} onChange={handleChange} required />
											</Form.Group>
										</Col>
										<Col lg={2} md={2} className="mb-3">
											<Form.Group controlId="info_invoice_streetnr">
												<Form.Label>{t('Number')}</Form.Label>
													<Form.Control type="text" value={formDataInfoInvoice.info_invoice_streetnr} onChange={handleChange} required />
											</Form.Group>
										</Col>
										<Col lg={3} md={3} className="mb-3">
											<Form.Group controlId="info_invoice_zip">
												<Form.Label>{t('Postal code')}</Form.Label>
													<Form.Control type="text" value={formDataInfoInvoice.info_invoice_zip} onChange={handleChange} required />
											</Form.Group>
										</Col>
										<Col lg={9} md={9} className="mb-3">
											<Form.Group controlId="info_invoice_city">
												<Form.Label>{t('City')}</Form.Label>
													<Form.Control type="text" value={formDataInfoInvoice.info_invoice_city} onChange={handleChange} required />
											</Form.Group>
										</Col>
										<Col lg={12} md={12} className="mb-3">
											<Form.Group controlId="info_invoice_state">
												<Form.Label>{t('State')}</Form.Label>
													<Form.Control type="text" value={formDataInfoInvoice.info_invoice_state} onChange={handleChange} required />
											</Form.Group>
										</Col>
										<Col lg={12} md={12} className="mb-3">
											<Form.Group controlId="info_invoice_country">
												<Form.Label>{t('Country')}</Form.Label>
													<Form.Control as={FormSelect} placeholder="" defaultselected="" options={countryOptions} onChange={handleCountryChange} />
											</Form.Group>
										</Col>
									</Row>
									<Row>
										<Col lg={12} md={12}>
											<div className="d-flex justify-content-end mt-4">
												<Button className="d-end" variant="primary" type="submit" disabled={isLoadingButtonInfoInvoice}>
													{isLoadingButtonInfoInvoice ? (
														<>
															<Spinner animation="border" size="sm" className="me-2" />
															{t('Save')}
														</>
													) : (
														t('Save')
													)}
												</Button>
											</div>
										</Col>
									</Row>
								</Form>
							)}
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</Fragment>
	);

};

export default CompanySettings;